import { render } from "./ViewerAdmin.vue?vue&type=template&id=6e7bce8f&ts=true"
import script from "./ViewerAdmin.vue?vue&type=script&lang=ts"
export * from "./ViewerAdmin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__